const Contact = () => {
  return (
    <section id="contact" className="section">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
          {/* Left Side - Contact Info */}
          <div>
            {/* Location */}
            <div className="mb-8 sm:mb-10 md:mb-12">
              <h3 className="text-heading mb-4 sm:mb-6 text-sm sm:text-base">Plats</h3>
              <address className="not-italic text-base sm:text-lg md:text-xl mb-3 sm:mb-4" style={{ color: 'var(--color-text-primary)' }}>
                Järnvägsgatan 28<br />
                21614 Limhamn
              </address>
              <a
                href="https://maps.google.com/?q=Järnvägsgatan+28,+21614+Limhamn"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm sm:text-base text-[var(--color-accent-500)] hover:text-[var(--color-accent-600)] transition-colors inline-flex items-center gap-2"
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Öppna i Google Maps
              </a>
            </div>

            {/* Contact */}
            <div className="mb-8 sm:mb-10 md:mb-12">
              <h3 className="text-heading mb-4 sm:mb-6 text-sm sm:text-base">Kontakt</h3>
              <div className="space-y-2 sm:space-y-3">
                <a
                  href="tel:0739869448"
                  className="text-base sm:text-lg md:text-xl hover:text-[var(--color-accent-500)] transition-colors flex items-center gap-2 sm:gap-3"
                  style={{ color: 'var(--color-text-primary)' }}
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  0739-869448
                </a>
                <a
                  href="https://www.instagram.com/hargalleriet_selma_p"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base sm:text-lg md:text-xl hover:text-[var(--color-accent-500)] transition-colors flex items-center gap-2 sm:gap-3"
                  style={{ color: 'var(--color-text-primary)' }}
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                  @hargalleriet_selma_p
                </a>
              </div>
            </div>
          </div>

          {/* Right Side - Opening Hours */}
          <div>
            <h3 className="text-heading mb-4 sm:mb-6 text-sm sm:text-base">Öppettider</h3>
            <div className="space-y-2 sm:space-y-3">
              {[
                { day: 'Måndag', hours: 'Stängt', closed: true },
                { day: 'Tisdag', hours: '10:00 - 20:00' },
                { day: 'Onsdag', hours: '10:00 - 20:00' },
                { day: 'Torsdag', hours: '10:00 - 20:00' },
                { day: 'Fredag', hours: '10:00 - 19:00' },
                { day: 'Lördag', hours: '12:00 - 18:00' },
                { day: 'Söndag', hours: '10:00 - 18:00' },
              ].map((schedule, index) => (
                <div
                  key={index}
                  className={`flex justify-between text-sm sm:text-base md:text-lg border-b border-[var(--color-border-light)] pb-2 ${
                    schedule.closed ? 'opacity-50' : ''
                  }`}
                >
                  <span style={{ color: 'var(--color-text-primary)' }}>{schedule.day}</span>
                  <span style={{ color: 'var(--color-text-secondary)' }}>{schedule.hours}</span>
                </div>
              ))}
            </div>

            {/* Book Appointment Button */}
            <div className="mt-8 sm:mt-10 md:mt-12">
              <p className="text-sm sm:text-base text-[var(--color-text-secondary)] mb-3 sm:mb-4">
                Vi rekommenderar att boka tid i förväg för att garantera önskad tid.
              </p>
              <a href="https://www.bokadirekt.se/places/hargalleriet-selma-p-57369" target="_blank" rel="noopener noreferrer">
                <button className="btn w-full text-xs sm:text-sm">Boka tid online</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
